import { render } from "./APill.vue?vue&type=template&id=1732cf43&scoped=true"
import script from "./APill.vue?vue&type=script&lang=js"
export * from "./APill.vue?vue&type=script&lang=js"

import "./APill.vue?vue&type=style&index=0&id=1732cf43&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1732cf43"]])

export default __exports__